import CollectorTierBadge from "./CollectorTierBadge";

function getDisplayUsername(username, truncateAt) {
  const normalizedUsername = String(username ?? "");

  if (!Number.isInteger(truncateAt) || truncateAt < 1 || normalizedUsername.length <= truncateAt) {
    return normalizedUsername;
  }

  return `${normalizedUsername.slice(0, truncateAt)}...`;
}

export default function UserIdentityLabel({
  username,
  tier,
  role = "collector",
  size = "sm",
  gap = 6,
  fontWeight = 700,
  color = "inherit",
  wrap = false,
  truncateAt = null,
  underline = true
}) {
  const normalizedUsername = String(username ?? "");
  const displayUsername = getDisplayUsername(normalizedUsername, truncateAt);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: `${gap}px`,
        flexWrap: wrap ? "wrap" : "nowrap",
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
        color,
        fontSize: "inherit",
        fontWeight,
        textDecoration: "inherit",
        textUnderlineOffset: "inherit",
        verticalAlign: "middle"
      }}
    >
      <CollectorTierBadge tier={tier} role={role} size={size} />
      <span
        style={{
          display: "block",
          flex: "1 1 auto",
          maxWidth: "100%",
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: wrap ? "normal" : "nowrap",
          overflowWrap: "anywhere",
          wordBreak: "break-word"
        }}
        title={displayUsername !== normalizedUsername ? normalizedUsername : undefined}
      >
        <span
          style={{
            display: "inline-block",
            color: "inherit",
            fontSize: "inherit",
            fontWeight: "inherit",
            paddingBottom: "1px",
            backgroundImage: underline ? "linear-gradient(currentColor, currentColor)" : "none",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "0 100%",
            backgroundSize: underline ? "100% 1px" : "0 0"
          }}
        >
          {displayUsername}
        </span>
      </span>
    </span>
  );
}